// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pYFr","newExpiryDate":"styles_newExpiryDate__3nWZL","footer":"styles_footer__3iZF-"};